document.addEventListener('DOMContentLoaded', function () {
  const root = document.getElementById('custom-popup');
  if (!root) return;

  const LIGHT_TYPES = [
    { name: '100W (15000lm)', power: 100, lumens: 15000 },
    { name: '130W (19500lm)', power: 130, lumens: 19500 },
    { name: '150W (22500lm)', power: 150, lumens: 22500 },
    { name: '200W (30000lm)', power: 200, lumens: 30000 },
    { name: '210W (31500lm)', power: 210, lumens: 31500 },
    { name: '240W (36000lm)', power: 240, lumens: 36000 },
    { name: '300W (45000lm)', power: 300, lumens: 45000 },
    { name: '400W (60000lm)', power: 400, lumens: 60000 },
    { name: '500W (75000lm)', power: 500, lumens: 75000 }
  ];

  const USAGE_TYPES = [
    { name: 'Warehouse (100-300 lux)', targetLux: 200 },
    { name: 'Workshop (300-500 lux)', targetLux: 400 },
    { name: 'Industrial (500-750 lux)', targetLux: 600 },
    { name: 'Office (500-700 lux)', targetLux: 600 },
    { name: 'Factory (500-750 lux)', targetLux: 600 },
    { name: 'Retail Stores (500-1000 lux)', targetLux: 750 },
    { name: 'Restaurants (300-500 lux)', targetLux: 400 },
    { name: 'General Manufacturing (600-800 lux)', targetLux: 700 },
    { name: 'Assembly Line (500-750 lux)', targetLux: 600 },
    { name: 'Classrooms (300-500 lux)', targetLux: 400 },
    { name: 'Laboratories (500-1000 lux)', targetLux: 900 },
    { name: 'Hospital Wards (200-300 lux)', targetLux: 200 },
    { name: 'Operating Rooms (1000-2000 lux)', targetLux: 1500 },
    { name: 'Sidewalks (100-200 lux)', targetLux: 150 }
  ];

  const MAINTENANCE_FACTOR = 0.7;
  const UTILIZATION_FACTOR = 0.65;
  const LUMEN_EFFICIENCY = 150;
  const lightSelect = document.getElementById('lightType');
  const usageSelect = document.getElementById('usage');
  const calculateButton = document.getElementById('calculateButton');
  const result = document.getElementById('lighting-result');
  const productButton = document.getElementById('productLinkButton');

  lightSelect.innerHTML = LIGHT_TYPES.map(function (item) {
    return '<option value="' + item.name + '">' + item.name + '</option>';
  }).join('');
  usageSelect.innerHTML = USAGE_TYPES.map(function (item) {
    return '<option value="' + item.name + '">' + item.name + '</option>';
  }).join('');

  document.getElementById('lighting-length').value = '80';
  document.getElementById('lighting-width').value = '60';
  document.getElementById('lighting-height').value = '15';

  result.innerHTML =
    '<div class="yxl-result-card">' +
      '<div class="yxl-result-heading"><span class="yxl-result-check">✓</span><span>Recommended Lighting Plan</span></div>' +
      '<div class="yxl-result-details">' +
        '<div class="yxl-result-row"><span>Number of fixtures needed:</span><strong id="yxl-fixtures">0</strong></div>' +
        '<div class="yxl-result-row"><span>Layout:</span><strong id="yxl-layout">0 × 0</strong></div>' +
        '<div class="yxl-result-row"><span>Spacing:</span><strong id="yxl-spacing">0.0 × 0.0 ft</strong></div>' +
      '</div>' +
      '<div id="yxl-power" class="yxl-power"></div>' +
    '</div>' +
    '<div id="yxl-project-note" class="yxl-project-note"></div>' +
    '<div class="yxl-diagram">' +
      '<div class="yxl-diagram-heading"><div><span>Fixture Layout</span><small>Top-view planning preview</small></div><span id="yxl-grid-label"></span></div>' +
      '<div class="yxl-room-plan"><div id="yxl-diagram-grid"></div></div>' +
    '</div>' +
    '<p class="yxl-disclaimer">Planning estimate only. Final layouts may vary with mounting height, beam angle, reflectance, obstructions and local requirements.</p>';

  function getOptimalGrid(minCount, length, width) {
    const targetRatio = length / width;
    let bestRows = 1;
    let bestCols = minCount;
    let minRatioDiff = Infinity;
    for (let rows = 1; rows <= minCount; rows++) {
      const cols = Math.ceil(minCount / rows);
      const diff = Math.abs((cols / rows) - targetRatio);
      if (diff < minRatioDiff) {
        minRatioDiff = diff;
        bestRows = rows;
        bestCols = cols;
      }
    }
    return { rows: bestRows, cols: bestCols, total: bestRows * bestCols };
  }

  function renderDiagram(rows, cols) {
    const grid = document.getElementById('yxl-diagram-grid');
    grid.innerHTML = '';
    grid.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)';
    grid.style.gridTemplateRows = 'repeat(' + rows + ', 1fr)';
    for (let i = 0; i < rows * cols; i++) {
      const fixture = document.createElement('img');
      fixture.className = 'yxl-layout-fixture-logo';
      fixture.src = 'https://cdn.shopify.com/s/files/1/0573/9465/9403/files/Lighting-logo-3.png?v=1789371654';
      fixture.alt = '';
      fixture.width = 36;
      fixture.height = 20;
      fixture.loading = 'lazy';
      fixture.setAttribute('aria-hidden', 'true');
      grid.appendChild(fixture);
    }
  }

  function calculateLighting() {
    const lengthFt = parseFloat(document.getElementById('lighting-length').value);
    const widthFt = parseFloat(document.getElementById('lighting-width').value);
    const heightFt = parseFloat(document.getElementById('lighting-height').value);
    const light = LIGHT_TYPES.find(function (item) { return item.name === lightSelect.value; });
    const usage = USAGE_TYPES.find(function (item) { return item.name === usageSelect.value; });

    if (!lengthFt || !widthFt || !heightFt || lengthFt <= 0 || widthFt <= 0 || heightFt <= 0) {
      document.getElementById('yxl-fixtures').textContent = '—';
      document.getElementById('yxl-layout').textContent = '—';
      document.getElementById('yxl-spacing').textContent = '—';
      document.getElementById('yxl-power').textContent = '';
      document.getElementById('yxl-project-note').innerHTML = '';
      document.getElementById('yxl-grid-label').textContent = 'Enter valid dimensions';
      document.getElementById('yxl-diagram-grid').innerHTML = '';
      return;
    }

    const areaSqm = (lengthFt * 0.3048) * (widthFt * 0.3048);
    const totalLumensNeeded = usage.targetLux * areaSqm * MAINTENANCE_FACTOR / UTILIZATION_FACTOR;
    const minCount = Math.ceil(totalLumensNeeded / light.lumens);
    const grid = getOptimalGrid(minCount, lengthFt, widthFt);
    const spacingX = lengthFt / grid.cols;
    const spacingY = widthFt / grid.rows;
    const actualLux = grid.total * light.lumens * UTILIZATION_FACTOR / (areaSqm * MAINTENANCE_FACTOR);

    let powerText;
    if (actualLux < usage.targetLux) {
      const neededLumens = usage.targetLux * areaSqm * MAINTENANCE_FACTOR / (UTILIZATION_FACTOR * grid.total);
      const neededPower = Math.ceil(neededLumens / LUMEN_EFFICIENCY);
      powerText = 'We suggest using ' + neededPower + '-' + (neededPower + 20) + 'W';
    } else {
      powerText = 'Current ' + light.power + 'W is sufficient';
    }

    document.getElementById('yxl-fixtures').textContent = grid.total;
    document.getElementById('yxl-layout').textContent = grid.cols + ' × ' + grid.rows;
    document.getElementById('yxl-spacing').textContent = spacingX.toFixed(1) + ' × ' + spacingY.toFixed(1) + ' ft';
    document.getElementById('yxl-grid-label').textContent = grid.cols + ' columns × ' + grid.rows + ' rows';
    document.getElementById('yxl-power').textContent = powerText;
    document.getElementById('yxl-project-note').innerHTML =
      grid.total >= 10 || heightFt >= 20
        ? '💡 For large spaces, high-ceiling facilities or projects with 10+ fixtures, contact our lighting design team for a free professional DIALux / AGi32 simulation: <a href="mailto:sales@yxlelectronic.com">sales@yxlelectronic.com</a>'
        : '';
    renderDiagram(grid.rows, grid.cols);
  }

  calculateButton.addEventListener('click', calculateLighting);
  productButton.style.display = 'flex';
  productButton.addEventListener('click', function () {
    window.location.href = '/collections/warehouse-lighting';
  });
  calculateLighting();

  const applianceSelect = document.getElementById('appliance');
  const customWattageGroup = document.getElementById('custom-wattage-group');
  const costButton = document.getElementById('calculate-btn');
  const costResults = document.getElementById('results');

  function calculateCost() {
    let wattage = applianceSelect.value === 'custom'
      ? parseFloat(document.getElementById('custom-wattage').value)
      : parseFloat(applianceSelect.value);
    const usageInput = parseFloat(document.getElementById('electricity-usage').value);
    const price = parseFloat(document.getElementById('price').value);
    if (!wattage || wattage <= 0 || isNaN(usageInput) || usageInput < 0 || isNaN(price) || price < 0) {
      alert('Please enter valid electricity calculator values.');
      return;
    }
    const usageHours = document.getElementById('usage-unit').value === 'minutes' ? usageInput / 60 : usageInput;
    const kWhPerDay = wattage * usageHours / 1000;
    const costPerHour = wattage / 1000 * price;
    const costPerDay = kWhPerDay * price;
    document.getElementById('cost-hour').textContent = '$' + costPerHour.toFixed(2);
    document.getElementById('cost-day').textContent = '$' + costPerDay.toFixed(2);
    document.getElementById('cost-month').textContent = '$' + (costPerDay * 30).toFixed(2);
    document.getElementById('cost-year').textContent = '$' + (costPerDay * 365).toFixed(2);
    document.getElementById('kwh-day').textContent = kWhPerDay.toFixed(2);
    costResults.style.display = 'block';
  }

  applianceSelect.addEventListener('change', function () {
    customWattageGroup.style.display = this.value === 'custom' ? 'block' : 'none';
  });
  costButton.addEventListener('click', calculateCost);

  const style = document.createElement('style');
  style.textContent = `
    #custom-popup { max-width: 500px; border: 1px solid #e2e7df; border-radius: 14px; box-shadow: 0 8px 28px rgba(42,86,19,.12); }
    #custom-popup .lighting-calculator-container { padding: 20px; }
    #custom-popup label { color: #252525; font-size: 16px; font-weight: 400; }
    #custom-popup input[type="number"], #custom-popup select { min-height: 46px; border: 1px solid #d6ddd2; border-radius: 8px; background: #fafafa; }
    #custom-popup input:focus, #custom-popup select:focus { border-color: #4f9722; box-shadow: 0 0 0 3px rgba(79,151,34,.14); outline: none; }
    #custom-popup #calculateButton, #custom-popup #productLinkButton { min-height: 48px; border-radius: 999px; background: #4f9722; font-weight: 700; }
    #custom-popup #calculateButton:hover, #custom-popup #productLinkButton:hover { background: #387217; }
    #custom-popup #lighting-result { margin-top: 14px; padding: 0; background: transparent; color: inherit; font-family: inherit; }
    .yxl-result-card { overflow: hidden; padding: 0; border: 1px solid #dce8d6; border-radius: 16px; background: #fff; color: #20251d; text-align: left; box-shadow: 0 8px 24px rgba(43,84,24,.08); }
    .yxl-result-heading { display: flex; align-items: center; gap: 9px; padding: 16px 20px; border-bottom: 1px solid #dce8d6; background: linear-gradient(135deg,#f5faF2,#eaf5e4); color: #2f6f18; font-size: 17px; font-weight: 700; letter-spacing: -.01em; }
    .yxl-result-check { display: inline-flex; align-items: center; justify-content: center; width: 23px; height: 23px; border-radius: 50%; background: #4f9722; color: #fff; font-size: 14px; }
    .yxl-result-metrics { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); padding: 20px 12px 16px; }
    .yxl-metric { min-width: 0; padding: 4px 13px; border-right: 1px solid #e4eadf; text-align: center; }
    .yxl-metric:last-child { border-right: 0; }
    .yxl-metric span { display: block; margin-bottom: 7px; color: #687063; font-size: 11px; font-weight: 700; letter-spacing: .1em; text-transform: uppercase; }
    .yxl-metric strong { display: block; color: #1f2a1b; font-size: clamp(18px,3.2vw,25px); font-weight: 650; line-height: 1.2; letter-spacing: -.025em; white-space: nowrap; }
    .yxl-power { display: flex; align-items: center; justify-content: center; min-height: 42px; margin: 0 20px 20px; padding: 9px 14px; border-radius: 8px; background: #edf7e8; color: #347719; font-size: 15px; font-weight: 650; text-align: center; }
    .yxl-power:not(:empty)::before { content: '✓'; display: inline-flex; align-items: center; justify-content: center; width: 18px; height: 18px; margin-right: 7px; border-radius: 50%; background: #4f9722; color: #fff; font-size: 11px; }
    .yxl-project-note { margin-top: 14px; padding: 15px 17px; border-left: 3px solid #4f9722; border-radius: 4px 10px 10px 4px; background: #f4f8f1; color: #4d5748; font-size: 13px; line-height: 1.55; text-align: left; }
    .yxl-project-note:empty { display: none; }
    .yxl-project-note a { color: #347719; font-weight: 650; text-decoration: underline; text-underline-offset: 2px; }
    .yxl-diagram { overflow: hidden; margin-top: 16px; border: 1px solid #dce4d8; border-radius: 16px; background: #fff; box-shadow: 0 8px 24px rgba(43,84,24,.07); }
    .yxl-diagram-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 15px 18px; border-bottom: 1px solid #e2e9de; }
    .yxl-diagram-heading div { display: flex; flex-direction: column; }
    .yxl-diagram-heading div > span { color: #273124; font-size: 16px; font-weight: 700; }
    .yxl-diagram-heading small { margin-top: 2px; color: #7a8376; font-size: 11px; }
    #yxl-grid-label { padding: 5px 9px; border-radius: 999px; background: #edf7e8; color: #3b7d20; font-size: 11px; font-weight: 650; white-space: nowrap; }
    .yxl-room-plan { position: relative; margin: 18px; padding: 28px; border: 1px solid #cfd9ca; border-radius: 10px; background-color: #f7faf5; background-image: linear-gradient(rgba(79,151,34,.055) 1px,transparent 1px),linear-gradient(90deg,rgba(79,151,34,.055) 1px,transparent 1px); background-size: 24px 24px; box-shadow: inset 0 0 0 6px #eef3eb; }
    .yxl-room-plan::before { content: ''; position: absolute; inset: 8px; border: 1px dashed rgba(79,151,34,.2); border-radius: 6px; pointer-events: none; }
    #yxl-diagram-grid { position: relative; z-index: 1; display: grid; min-height: 285px; width: 100%; place-items: center; }
    .yxl-light-fixture { position: relative; display: block; width: 27px; height: 27px; border: 1px solid #2f6f18; border-radius: 50%; background: radial-gradient(circle at 50% 54%,#fff 0 21%,#b9dba8 23% 36%,#4f9722 38% 55%,#2f6719 57% 72%,#234e13 74% 100%); box-shadow: 0 0 0 4px rgba(79,151,34,.10),0 4px 8px rgba(33,73,17,.18); }
    .yxl-light-fixture::before { content: ''; position: absolute; left: 50%; top: -4px; width: 9px; height: 5px; border-radius: 3px 3px 0 0; background: #315f1d; transform: translateX(-50%); }
    .yxl-light-fixture::after { content: ''; position: absolute; inset: -8px; border-radius: 50%; background: radial-gradient(circle,rgba(132,196,97,.18),transparent 68%); z-index: -1; }
    .yxl-disclaimer { margin: 12px 4px 0; color: #707070; font-size: 12px; line-height: 1.45; text-align: center; }
    .calculator-header, .calculator button { background: #4f9722; }
    .calculator button:hover { background: #387217; }
    .calculator select:focus, .calculator input:focus { border-color: #4f9722; box-shadow: 0 0 0 2px rgba(79,151,34,.18); }
    .calculator .results { background: #eef7e8; }
    .calculator .results h2, .calculator .result-value { color: #387217; }
    @media (max-width: 600px) {
      #custom-popup .lighting-calculator-container { padding: 15px; }
      .yxl-result-heading { padding: 14px 15px; }
      .yxl-result-metrics { padding: 16px 4px 13px; }
      .yxl-metric { padding: 3px 7px; }
      .yxl-metric span { font-size: 9px; letter-spacing: .07em; }
      .yxl-metric strong { font-size: 16px; }
      .yxl-power { margin: 0 14px 15px; font-size: 13px; }
      .yxl-diagram-heading { padding: 13px 14px; }
      .yxl-room-plan { margin: 12px; padding: 17px; }
      #yxl-diagram-grid { min-height: 245px; }
      .yxl-light-fixture { width: 21px; height: 21px; }
    }

    /* Professional unified result presentation */
    .yxl-result-card { border-color: #d8e0d4; border-radius: 10px; box-shadow: 0 4px 14px rgba(35,61,23,.06); }
    .yxl-result-heading { padding: 14px 17px; background: #f2f6ef; color: #315b20; font-size: 16px; font-weight: 600; line-height: 1.5; letter-spacing: 0; }
    .yxl-result-check { width: 20px; height: 20px; font-size: 11px; }
    .yxl-result-details { padding: 10px 17px; }
    .yxl-result-row { display: flex; align-items: center; justify-content: space-between; gap: 16px; min-height: 40px; border-bottom: 1px solid #e8ece5; color: #444b40; font-size: 15px; line-height: 1.5; }
    .yxl-result-row:last-child { border-bottom: 0; }
    .yxl-result-row span, .yxl-result-row strong { font-family: inherit; font-size: 15px; line-height: 1.5; }
    .yxl-result-row strong { color: #25351f; font-weight: 600; text-align: right; white-space: nowrap; }
    .yxl-power { min-height: 40px; margin: 0 17px 17px; padding: 8px 12px; border: 1px solid #d8e7d1; border-radius: 6px; background: #f1f7ed; color: #356f1e; font-family: inherit; font-size: 15px; font-weight: 600; line-height: 1.5; }
    .yxl-project-note { padding: 14px 16px; border: 1px solid #dce4d8; border-left: 3px solid #4f9722; border-radius: 6px; background: #f8faf7; color: #454c41; font-family: inherit; font-size: 15px; line-height: 1.6; }
    .yxl-diagram { border-color: #d8e0d4; border-radius: 10px; box-shadow: 0 4px 14px rgba(35,61,23,.06); }
    .yxl-diagram-heading { padding: 14px 17px; background: #fbfcfa; }
    .yxl-diagram-heading div > span { color: #30372d; font-size: 15px; font-weight: 600; line-height: 1.5; }
    .yxl-diagram-heading small { margin-top: 1px; color: #70776c; font-size: 13px; line-height: 1.5; }
    #yxl-grid-label { padding: 4px 8px; border-radius: 4px; background: #edf3e9; color: #3b652a; font-size: 13px; font-weight: 500; }
    .yxl-room-plan { margin: 17px; padding: 27px; border: 1px solid #cbd4c7; border-radius: 6px; background: #f4f6f2; background-image: none; box-shadow: inset 0 0 0 5px #e9ede6; }
    .yxl-room-plan::before { inset: 9px; border: 1px solid #d6ddd2; border-radius: 2px; }
    .yxl-horizontal-fixture { position: relative; display: block; width: 30px; height: 9px; border: 1px solid #244719; border-radius: 3px; background: #356824; box-shadow: 0 2px 3px rgba(29,50,21,.14); }
    .yxl-horizontal-fixture::before { content: ''; position: absolute; left: 4px; right: 4px; bottom: 1px; height: 3px; border-radius: 2px; background: #dcebd5; }
    .yxl-horizontal-fixture::after { content: ''; position: absolute; left: 50%; top: -4px; width: 8px; height: 4px; border-radius: 2px 2px 0 0; background: #294e1d; transform: translateX(-50%); }
    .yxl-disclaimer { color: #6c7368; font-family: inherit; font-size: 13px; line-height: 1.55; }
    @media (max-width: 600px) {
      .yxl-result-heading { font-size: 15px; }
      .yxl-result-details { padding: 8px 14px; }
      .yxl-result-row { min-height: 38px; gap: 9px; }
      .yxl-result-row span, .yxl-result-row strong, .yxl-power, .yxl-project-note { font-size: 14px; }
      .yxl-power { margin: 0 14px 14px; }
      .yxl-diagram-heading { padding: 12px 14px; }
      .yxl-room-plan { margin: 12px; padding: 18px; }
      .yxl-horizontal-fixture { width: 25px; height: 8px; }
    }

    /* Match typography between result details and layout heading */
    .yxl-result-row,
    .yxl-result-row span,
    .yxl-result-row strong,
    .yxl-diagram-heading div > span,
    .yxl-diagram-heading small,
    #yxl-grid-label {
      color: #3f463b;
      font-family: inherit;
      font-size: 15px;
      line-height: 1.5;
    }
    .yxl-result-row strong,
    .yxl-diagram-heading div > span {
      font-weight: 600;
    }
    .yxl-diagram-heading small,
    #yxl-grid-label {
      font-weight: 400;
    }
    .yxl-layout-fixture-logo {
      display: block;
      width: 36px;
      height: 20px;
      object-fit: contain;
      object-position: center;
    }
    @media (max-width: 600px) {
      .yxl-result-row,
      .yxl-result-row span,
      .yxl-result-row strong,
      .yxl-diagram-heading div > span,
      .yxl-diagram-heading small,
      #yxl-grid-label {
        font-size: 14px;
      }
      .yxl-layout-fixture-logo {
        width: 30px;
        height: 17px;
      }
    }
  `;
  // Page styles are maintained in yxl-lights-calculator-page.html.
  // Do not append legacy runtime CSS, which would override the latest design.
});
